export default function round(number: number, precision: number = 0) {
  return Number(number.toFixed(precision));
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    round: typeof round;
  }
}
